<template>
	<svg
		width="17px"
		height="14px"
		viewBox="0 0 17 14"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
	>
		<title>Checkmark</title>
		<g
			id="Checkmark"
			stroke="none"
			stroke-width="1"
			fill="none"
			fill-rule="evenodd"
		>
			<g
				id="CheckmarkIcon"
				transform="translate(-1199.000000, -463.000000)"
				:fill="fill"
			>
				<g id="Group-18" transform="translate(506.000000, 320.000000)">
					<polygon
						id="Mask-Copy-3"
						points="698.297444 157 693 151.947407 694.90024 150.134339 698.206035 153.286698 708.011576 143 710 144.724875"
					></polygon>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	Name: 'CheckmarkIcon',
	props: {
		color: {
			type: String,
			default: '#00DAB6',
		},
	},

	computed: {
		fill() {
			return this.color
		},
	},
}
</script>
